import { useState } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import './QASection.css'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const QASection = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = t('faq.items', { returnObjects: true });
  console.log(faqs);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="qa-section" id="faq">
      <div className="container">
        <h2 className="section-title">{t('faq.title')}</h2>
        <p className="section-subtitle">{t('faq.subtitle')}</p>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div className={`faq-item ${activeIndex === index ? 'active' : ''}`} key={index}>
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <h3>{faq.question}</h3>
                <span className="faq-icon">
                  {activeIndex === index ? <FiChevronUp /> : <FiChevronDown />}
                </span>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="qa-cta">
          <p>{t('faq.ctaText')}</p>
          <Link to="/contact" className="btn btn-primary">
            {t('faq.ctaButton')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default QASection